// extracted by mini-css-extract-plugin
module.exports = {"header":"modal_header__1As_s","title":"modal_title__TdBoy headLine-3","close":"modal_close__2BB36","actions":"modal_actions__2InrS"};